import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import NodeVacancyPage from './Page';
import { NodeVacancy } from '../../../types/uncinc_profile/nodes';
import NodeVacancyTeaser from './Teaser';

interface NodeVacancyProps {
  entity: ImmutableEntity<NodeVacancy>;
  viewMode: string;
}

const NodeVacancyWrapper: React.FC<NodeVacancyProps> = ({ entity, viewMode }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeVacancyTeaser entity={entity} />;
    default:
      return <NodeVacancyPage entity={entity} />;
  }
};

export default NodeVacancyWrapper;
